<template>
    <div class="form1">
        <div style="width:500px;margin-top:50px">
			<el-form :model="form" :rules="rules" ref="form" style="margin-left:120px;width:500px">
				<el-form-item label="验证方式：" prop="select">
					<el-select v-model="form.select" style=" float:left; display:inline;width:200px" :disabled="activeStep==1">
						<el-option
							v-for="item in selectData"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="form.select=='mobile'?'手机号码：':'电子邮箱：'" prop="mobile">
					<el-input v-model="form.mobile" style=" float:left; display:inline;width:200px" :disabled="activeStep==1"></el-input>
				</el-form-item>
				<el-form-item>
					<div style="width:500px" v-if="activeStep==1">
						<el-input v-model="form.checkNumber" style="float:left;width:200px;"></el-input>
						<el-popover placement="top" title="验证图形" width="200" trigger="click" style="margin:0 auto">
							<div class="graphCode">
								<el-input v-model="form.graphCode" />
								<img :src="numAImg_src" @click="reflashNumA" />
								<el-button type="primary" round @click="sendCode">发送</el-button>
							</div>
							<el-button @click="reflashNumA" class="sendbtn" slot="reference">发送验证码</el-button>
						</el-popover>
					</div>
				</el-form-item>
				<el-form-item  v-if="activeStep==1" label="输入密码：" prop="pass">
					<el-input type="password" v-model="form.pass" style=" float:left; display:inline;width:200px" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item  v-if="activeStep==1" label="确认密码：" prop="checkPass">
					<el-input type="password" v-model="form.checkPass" style=" float:left; display:inline;width:200px" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
        </div>
        <div style="float:left; margin:50px 200px">
            <el-button @click="checkPhone('up')" v-if="activeStep!= 0">上一步</el-button>
            <el-button @click="checkPhone('down')">下一步</el-button>
        </div>
    </div>
</template>
<script>
import { LoginService } from "../../service/login.service";
import Axios from "axios";
import { Message } from "element-ui";
export default {
	name: "forgetPasswordStep1",
	props:{
		activeStep:{
			type:Number,
			default: 0
		}
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入密码'));
			} else {
				if (this.form.checkPass !== '') {
					this.$refs.form.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.form.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
            form: {
                mobile: "",
                select: "mobile",
                checkNumber:"",
                graphCode: "",
				pass: '',
				checkPass: '',
            },
            selectData: [
                { label: "手机号", value: "mobile" },
                { label: "邮箱", value: "email" }
			],
			rules:{
				mobile:[{ required: true, validator: this.validPhone, trigger: 'blur' }],
				pass: [
					{ required: true, validator: validatePass, trigger: 'blur' }
				],
				checkPass: [
					{ required: true, validator: validatePass2, trigger: 'blur' }
				]
			},
            numAImg_src: ""
		};
	},
	created() {
		this.reflashNumA();
	},
	methods: {
		// 发送验证码
		async sendCode() {
			await LoginService.setCheckNumber({
				type:this.form.select,
				account:this.form.mobile,
				model:'resetPw',
				code_num:this.form.graphCode
			}).then(()=>{
				Message.success("发送成功");
				this.reflashNumA();
			})
		},
		// 获取验证码图片
		reflashNumA() {
		var url ="https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=resetPw";
			Axios.get(url, {
				responseType: "arraybuffer",
				withCredentials: true
			}).then(res => {
				let codeImg ="data:image/png;base64," +btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte),""));
				this.numAImg_src = codeImg;
			});
        },
        //上一步+下一步方法
		async checkPhone(data){
			if(data=='down'){
				if(this.activeStep == 0){
					if(this.form.mobile!=''){
						await this.checkPhoneEmail()
						this.form.checkNumber = ''
						this.form.pass = ''
						this.form.checkPass = ''
					}else{
						this.$message.error("请输入手机号或电子邮箱")
					}
				}else if(this.activeStep == 1){
					if(this.form.checkNumber!=''&&this.form.pass!=''&&this.form.checkPass!=''){
						this.$refs['form'].validate(vaild=>{
							if(vaild){
								LoginService.resetPassword({
									accountUniqueCheck_tag:this.form.select,
									account:this.form.mobile,
									password:this.form.pass,
									checkCode:this.form.checkNumber
								}).then(()=>{
									this.$emit('update', 2);
								})
							}else{
								this.$message.error("请确认输入两次相同密码")
							}
						})
						
					}else{
						this.$message.error("请输入完整")
					}
				}
			}else if(data == 'up'){
				this.activeStep == 1?this.$emit('update', 0):this.$emit('update', 1)
			}
		},
		// 验证手机号码/邮箱输入格式是否正确
		validPhone(rule, value,callback){
			if(this.form.select == 'mobile'){
				if (!value){
					callback(new Error('请输入手机号'))
				}else  if (!(/^1[3|4|5|8][0-9]\d{4,8}$/.test(this.form.mobile))){
					callback(new Error('请输入正确的11位手机号码'))
				}else {
					callback()
				}
			}else if(this.form.select == 'email'){
				if (!value){
					callback(new Error('请输入邮箱账号'))
				}else  if (!(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/.test(this.form.mobile))){
					callback(new Error('请输入正确的邮箱账号'))
				}else {
					callback()
				}
			}
		},
		// 验证手机号码/邮箱是否存在
		async checkPhoneEmail(){
			await LoginService.checkPhone({
				accountUniqueCheck_tag: "mobile",
				account: this.form.mobile
			}).then(() => {
				this.$emit('update', 1);
			});
		}
	}
};
</script>

<style lang="scss" scoped>
    .form1 {
        width: 1000px;
        margin-top: 20px;
        font-size: 24px;
        float: left;
    }
	.graphCode {
		display: flex;
		align-items: flex-end;
		flex-direction: column;
		img {
			height: 60px;
			width: 180px;
			margin: 10px 0;
		}
	}
	.sendbtn {
		position: absolute;
		margin-left: 10px;
	}
</style>
